export const settings = {
  l: 8,
  u: 8,
  n: 8,
  s: 6
}

export const minimum = {
  l: 5,
  u: 5,
  n: 5,
  s: 0
}

export const maximum = {
  l: 15,
  u: 15,
  n: 15,
  s: 15
}
